export function followUpMutationMessage(contactLabel: string, status: 'completed' | 'dismissed'): string {
  return status === 'completed'
    ? `Marked follow-up for ${contactLabel} complete.`
    : `Dismissed follow-up for ${contactLabel}.`;
}

export function actionItemToggleMessage(text: string, completed: boolean): string {
  return completed ? `Completed action item: ${text}` : `Re-opened action item: ${text}`;
}
